// extracted by mini-css-extract-plugin
export var equalColumn = "_dx-0";